//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsNoteSubscribersTypeahead', () => {
    return {
      restrict: 'E',
      scope: {
        selectItemCallback: '&',
        taggableUsers: '=',
      },
      template: require('@legacy-components/common/universal-image-actions/universal-image-actions-note-subscribers-typeahead.html'),
      controller: ['$rootScope', '$scope',
        function($rootScope, $scope) {
          $scope.model = {};

          $scope.model.addSubscriber = function() {
            $rootScope.$broadcast('twitter-typeahead:submit', 'enter');
          };

          $scope.usersTypeaheadConfig = {
            events: {
              enterKeyed($event, obj) {
                let foundItem;
                let partialMatch;
                let query;

                                // Grab the query from the typeahead value instead of the enterKeyed's "query" method parameter
                                // The typeahead doesn't update the method parameter if the value was changed while the typeahead was closed
                                // (ie with the addSubscriber button)
                query = angular.element(this).typeahead('val');

                if (obj) {
                  foundItem = _($scope.taggableUsers).find((user) => { return user.name.toLowerCase() === obj.name.toLowerCase(); });
                } else if (query) {
                  query = query.toLowerCase();
                  foundItem = _($scope.taggableUsers).find((user) => { return user.name.toLowerCase() === query; });

                  if (!foundItem) {
                    partialMatch = _.chain($scope.taggableUsers)
                                            .reject((user) => { return user.name.toLowerCase().indexOf(query) === -1; })
                                            .sortBy((user) => { return user.name.toLowerCase().indexOf(query); })
                                            .first()
                                            .value();

                    if (partialMatch) {
                      angular.element(this).typeahead('val', partialMatch.name);
                    }
                  }
                }

                if (foundItem) {
                  $scope.usersTypeaheadConfig.context.onAdd(foundItem);
                  $rootScope.$broadcast('twitter-typeahead:reset');
                }
              },
            },
            context: {
              onAdd(item) {
                $scope.selectItemCallback({
                  user: item,
                });
                $rootScope.$broadcast('twitter-typeahead:reset');
              },
            },
            templates: {
              suggestion: { html: require('@partials/notes-subscriptions.html') },
            },
            key: 'name',
            searchUsers(query, defer) {
              if (!_.isString(query)) {
                defer.resolve([]);
              }

              const normalizedQuery = query.trim().toLowerCase();
              const results = _($scope.taggableUsers).filter((user) => {
                return user.name.toLowerCase().indexOf(normalizedQuery) >= 0;
              });

              defer.resolve(results);
            },
          };
        },
      ],
    };
  });
})();
